import { SxProps, Theme } from '@mui/material';

const styles = {
  titleContainer: {
    marginBottom: '0px',
    backgroundColor: 'common.lightBackgroundColor',
  },
  modalHeading: {
    fontWeight: '500',
  },
  subtitle: {
    backgroundColor: 'common.lightBackgroundColor',
    color: 'grey.800',
    fontSize: 14,
    fontWeight: 500,
    padding: '0 24px',
  },
  content: {
    backgroundColor: 'common.lightBackgroundColor',
    padding: '24px',
    paddingTop: '8px',
  },
  notes: {
    marginTop: '24px',
  },
  actions: {
    backgroundColor: 'common.lightBackgroundColor',
    boxShadow: '0px -2px 4px 0px #0000000A',
    padding: '16px 24px',
  },
  updateButton: {
    minWidth: '120px',
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
